import React from 'react';
import { Lock, Network } from 'lucide-react';
import LaborOperationsLayout from '../../../components/labor/LaborOperationsLayout';
import { useAdminAuth } from '../../../contexts/AdminAuthContext';

const LegalAiAssistantPlaceholderPage = () => {
  const { user } = useAdminAuth();
  const role = `${user?.role || ''}`.toLowerCase();
  const roleName = `${user?.roleName || ''}`.toLowerCase();
  const isSuperAdmin = role.includes('super_admin') || roleName.includes('super') || roleName.includes('المدير العام');

  return (
    <LaborOperationsLayout>
      <main className="px-6 pb-12 pt-8 sm:px-10" dir="rtl">
        <section className="lo-surface rounded-[22px] p-8">
          <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#f1eee8] text-[#948066]">
            {isSuperAdmin ? <Network className="h-6 w-6" /> : <Lock className="h-6 w-6" />}
          </div>
          <p className="lo-kicker font-bold">AI LEGAL PIPELINE</p>
          <h1 className="legal-title mt-3 text-[34px] font-bold text-[#293a50]">المساعد التحليلي القانوني</h1>
          {isSuperAdmin ? (
            <p className="mt-4 max-w-3xl text-[15px] leading-8 text-[#697483]">
              هذه مساحة محجوزة للتفعيل المستقبلي فقط. ستستخدم لاحقاً لقراءة بيانات الطلب، تلخيص الوقائع،
              استخراج المطالبات، تحديد النواقص، وإعطاء ملاحظات أولية داخلية للفريق دون إظهار أي تحليل للعملاء.
            </p>
          ) : (
            <p className="mt-4 max-w-3xl text-[15px] leading-8 text-[#697483]">
              هذه المساحة مقيدة بصلاحية المدير العام فقط.
            </p>
          )}
        </section>
      </main>
    </LaborOperationsLayout>
  );
};

export default LegalAiAssistantPlaceholderPage;
